'use client';

import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import type { ScanProfileTierLabels } from './external-settings.model';

export const useScanProfileTierLabels = (): ScanProfileTierLabels => {
  const t = useTranslations(
    'designSystem.networkSettings.externalSettings.scanProfileTiers',
  );

  return useMemo(
    () => ({
      STEALTH: t('STEALTH'),
      BALANCED: t('BALANCED'),
      AGGRESSIVE: t('AGGRESSIVE'),
    }),
    [t],
  );
};
